import { render, staticRenderFns } from "./viewRecoil.vue?vue&type=template&id=23ca4b72"
import script from "./viewRecoil.vue?vue&type=script&lang=js"
export * from "./viewRecoil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports